import emailjs from "emailjs-com";
import { toast } from "react-toastify";

// TODO:  This is temporary, it will be changed to nodemailer later
export const sendEmail = (
  data,
  setFormData,
  intialData,
  message,
  duration,
  templateId,
  setLoading
) => {
  emailjs
    .send(
      process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
      templateId,
      data,
      process.env.REACT_APP_EMAIL_JS_USER_ID
    )
    .then(
      () => {
        setFormData(intialData);
        setLoading(false);
        toast.success(message, { autoClose: duration });
      },
      () => {
        setLoading(false);
        toast.error("Something went wrong, please try after some time!");
      }
    );
};
